import styled, { css } from 'styled-components';
import { Text } from '@morressier/ts';
import { RadioButton, Input, Button } from 'components/ProfileUIComponents';

export const PhotoInfoText = styled(Text)`
  color: var(--color-mono-60);
  margin-top: 8px;
`;

export const PhotoContainer = styled.div`
  margin-left: 1rem;
`;

export const FieldContainer = styled.div`
  margin-bottom: 2rem;
`;

export const StyledRadio = styled(RadioButton)`
  margin-right: 1rem;
`;

export const Label = styled.div`
  margin-bottom: 8px;
`;

export const PrimaryAffiliationInput = styled(Input)`
  margin-top: 8px;
`;

export const ProfileHeading = styled(Text).attrs({
  size: 'body1_new',
  fontWeight: 'bold'
})`
  margin: 1rem 0 0.5rem 0;
`;
export const LinkButton = styled.button<{ btnType?: string }>`
  color: ${({ btnType }) =>
    btnType === 'add' ? 'var(--color-blue-40)' : 'var(--color-red-50)'};
  border: none;
  border-radius: 0.25rem;
  display: block;
  padding: 0;
  background: none;
  font-size: var(--fontSizes-normal);
  cursor: pointer;
  &:hover,
  &:focus {
    color: ${({ btnType }) =>
      btnType === 'add' ? 'var(--color-blue-20)' : 'var(--color-red-30)'};
  }
  margin: 1rem 0;
  ${({ btnType }) =>
    btnType === 'add' &&
    css`
      margin-top: 2rem;
    `}
  svg {
    margin-right: 8px;
  }
`;

export const PronounsInput = styled(Input)`
  width: 19rem;
`;
export const LinkInputContainer = styled.div`
  margin-bottom: 1rem;
  min-width: 88%;
`;

export const Italic = styled.span`
  font-style: italic;
`;
